"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _window$cccisd, _window$cccisd$appDef, _window$cccisd2, _window$cccisd2$appDe;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var navs = (_window$cccisd = window.cccisd) === null || _window$cccisd === void 0 ? void 0 : (_window$cccisd$appDef = _window$cccisd.appDefs) === null || _window$cccisd$appDef === void 0 ? void 0 : _window$cccisd$appDef.navs;
var routes = (((_window$cccisd2 = window.cccisd) === null || _window$cccisd2 === void 0 ? void 0 : (_window$cccisd2$appDe = _window$cccisd2.appDefs) === null || _window$cccisd2$appDe === void 0 ? void 0 : _window$cccisd2$appDe.routes) || []).reduce(function (obj, item) {
  obj[item.handle] = {
    url: item.url
  };
  return obj;
}, {});
var getIconSvg = function getIconSvg(viewBox, paths) {
  return function () {
    return /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: viewBox
    }, /*#__PURE__*/_react["default"].createElement("g", null, paths.map(function (path, index) {
      return /*#__PURE__*/_react["default"].createElement("path", {
        key: index,
        d: path
      });
    })));
  };
};
var prepareUrl = function prepareUrl(url) {
  if (!url) {
    return '';
  }
  return url.replace(/\/:[\w-]+\?/g, '');
};
var _default = exports["default"] = function _default(code) {
  if (!navs) {
    return [];
  }
  var currentNav = navs.find(function (item) {
    return item.handle === code;
  });
  if (!currentNav) {
    return [];
  }
  var _getChildren = function getChildren(list) {
    return list.map(function (item) {
      var _routes$item$handle;
      var icon = item.render.params.icon;
      var result = _objectSpread(_objectSpread(_objectSpread({
        handle: item.handle,
        url: prepareUrl((_routes$item$handle = routes[item.handle]) === null || _routes$item$handle === void 0 ? void 0 : _routes$item$handle.url),
        label: /*#__PURE__*/_react["default"].createElement("span", {
          dangerouslySetInnerHTML: {
            __html: item.render.params.label
          }
        })
      }, icon ? {
        icon: getIconSvg(icon.viewBox, icon.paths)
      } : {}), item.render.params.activeRegex ? {
        activeRegex: item.render.params.activeRegex
      } : {}), item.render.params.children && item.render.params.children.length > 0 ? {
        children: _getChildren(item.render.params.children)
      } : {});
      return result;
    });
  };
  return _getChildren(currentNav.nav);
};